export const FORM_EDIT_VIEW_HEADLINE = 'headline';
export const FORM_EDIT_VIEW_SUBMIT_BUTTON = 'submitButton';
export const FORM_EDIT_VIEW_TICKET_STYLES = 'ticketStyles';
export const FORM_EDIT_VIEW_SESSION_REGISTRATION = 'sessionRegistrationSetting';
